import styled from 'styled-components';

const sharedStyles = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Wrapper = styled.button`
  ${sharedStyles}
  background: none;
  border: none;
  padding: 0;
`;

export const AnchorWrapper = styled.a`
  ${sharedStyles}
  text-decoration: none;
  color: inherit;
`;
